import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'ai-chat-tool-indicator',
	template: `
		<div class="chat-loading" role="status" aria-live="polite">
			<span class="chat-loading-dots" aria-hidden="true">
				<span></span><span></span><span></span>
			</span>
			<span class="chat-loading-text">{{ label() }}</span>
		</div>
	`,
	styles: `
		.chat-loading { display: flex; align-items: center; gap: 8px; margin: 6px 0; color: #6b7280; font-size: 13px; }
		.chat-loading-dots { display: inline-flex; gap: 3px; }
		.chat-loading-dots span {
			width: 6px; height: 6px; border-radius: 50%;
			background: #2563A8;
			animation: chat-loading-bounce 1s infinite ease-in-out;
		}
		.chat-loading-dots span:nth-child(2) { animation-delay: .15s; }
		.chat-loading-dots span:nth-child(3) { animation-delay: .3s; }
		@keyframes chat-loading-bounce {
			0%, 80%, 100% { opacity: .3; transform: scale(.8); }
			40% { opacity: 1; transform: scale(1); }
		}
		@media (prefers-reduced-motion: reduce) {
			.chat-loading-dots span { animation: none; opacity: .6; }
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatToolIndicatorComponent {
	i18n = inject(TranslateService)

	toolLabel = input<string | null>(null)

	label = computed(() => this.toolLabel() ?? this.i18n.instant('App.AIChat.Thinking'))
}
